/* eslint-disable camelcase */

import { dispatchServerAction } from '../dispatcher/AppDispatcher';
import OlsConfigStore from '../stores/OlsConfigStore';
import YotpoStore from '../stores/YotpoStore';
import YotpoConstants from '../constants/YotpoConstants';

function loadYotpo() {
  if (YotpoStore.getState().wasLoaded) {
    return;
  }

  const { yotpo_config: { script_url } } = OlsConfigStore.getState();
  if (!script_url) {
    return;
  }

  const script = window.document.createElement('script');
  script.type = 'text/javascript';
  script.text = `
    (function e(){
      var e = document.createElement("script");
      e.type="text/javascript";
      e.async=true;
      e.src="${script_url}";
      var t = document.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(e,t)
    })();
  `;
  script.id = 'yotpo-script';
  window.document.body.appendChild(script);

  dispatchServerAction({
    type: YotpoConstants.YOTPO_WAS_LOADED
  });
}

export default { loadYotpo };
